import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-bustracker",
	templateUrl: "./bustracker.component.html",
})
export class BusTrackerComponent {}
